import { InspectionOrderInterface } from '../interfaces/inspectionOrder';
import { Inspection } from "./inspection";

export class InspectionOrder implements InspectionOrderInterface {
    id_inspection_order?: number;
    fk_id_inspection: number | null;
    inspection: Inspection;
    number: string;
    referent_name: string;
    referent_phone: string;
    referent_fax: string;
    referent_email: string;
    penalties: string;
    non_compliance: string;
    inspector_report: string;

    constructor() {
        this.fk_id_inspection = null;
        this.inspection = new Inspection();
        this.number = '';
        this.referent_name = '';
        this.referent_phone = '';
        this.referent_fax = '';
        this.referent_email = '';
        this.penalties = '';
        this.non_compliance = '';
        this.inspector_report = '';
    }
}